import React from "react";
import {
  Button,
  ButtonColors,
  Icon,
  Modal,
  TalentechIcons,
} from "@talentech/components";
import { Template, CloneTemplatePayload } from "@/redux/reducer/pages.api";

interface CloneTemplateModalProps {
  showModal: boolean;
  onClose: () => void;
  onCloneConfirm: () => void;
  isLoading: boolean;
  template: Template | undefined;
  cloneData: (CloneTemplatePayload & { newName: string }) | null;
  setCloneData: React.Dispatch<
    React.SetStateAction<(CloneTemplatePayload & { newName: string }) | null>
  >;
}

const CloneTemplateModal: React.FC<CloneTemplateModalProps> = ({
  showModal,
  onClose,
  onCloneConfirm,
  isLoading,
  template,
  cloneData,
  setCloneData,
}) => {
  const handleCloneConfirm = () => {
    if (cloneData?.newName) {
      onCloneConfirm();
    }
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (cloneData) {
      setCloneData({
        ...cloneData,
        newName: e.target.value,
      });
    }
  };

  return (
    <Modal
      showModal={showModal}
      onClose={onClose}
      title="Clone template"
      buttons={[
        <Button
          key="button-5"
          label="Cancel"
          onClick={onClose}
          outline
          color={ButtonColors.PRIMARY}
        />,
        <Button
          key="button-6"
          isLoading={isLoading}
          icon={
            <Icon
              icon={
                TalentechIcons.REGULAR_01_INTERFACE_ESSENTIALS_COPY_PASTE_DUPLICATE
              }
            />
          }
          color={ButtonColors.PRIMARY}
          label="Clone"
          onClick={handleCloneConfirm}
        />,
      ]}
    >
      <div className="mb-3">
        You are cloning template: <strong>{template?.name}</strong>
      </div>
      <div className="mb-3">
        <label htmlFor="template-name" className="form-label">
          New template name:
        </label>
        <input
          type="text"
          className="form-control"
          id="template-name"
          value={cloneData?.newName || ""}
          onChange={handleNameChange}
        />
      </div>
    </Modal>
  );
};

export default CloneTemplateModal;
